import utils from "./util";
export default {
  /**
   * 格式化日期
   * @param {*} time 传入的日期 long型
   * @param {*} type 格式化的类型
   */
  dateFilter: function (time, type = "date") {
    if (!time) {
      return "--";
    }
    if (type === "date") {
      return utils.formatDate(time);
    }
    if (type === "time") {
      return utils.formatDateTime(time);
    }
    if (type === "timeTwo") {
      return utils.formatDateTwo(time);
    }
  },
  /**
   * 格式化小数位
   * @param val 传入的值
   * @param pos 保留的小数位
   * @returns {*}
   */
  numberFilter: function (number, len = 2) {
    if(isNaN(number)){
      return;
    }
    return Number(number).toFixed(len);
  },

  // num传入的数字，n需要的字符长度
  prefixIntegerFilter: function (num, n = 2) {
    return (Array(n).join(0) + num).slice(-n);
  },
  /**
   * 季度格式化
   */
  quarterFilter: (value) => {
    const obj = {
      1: "一季度",
      2: "二季度",
      3: "三季度",
      4: "四季度",
    };
    return obj[value];
  },
  /**
   * 值集过滤器（获取值集名称）
   * @param {*} code
   * @param {*} valueSet
   */
  codeFilter: function (code, valueSet) {
    if (code && valueSet) {
      let res = utils.formatCodeset(code, valueSet);
      return res;
    }
  },
  /**
   *字符串限制过滤器，超出部分显示...
   */
  ellipsisFilter: function (str, num) {
    const nums = num || "10"; // 设置限定字数,默认为10
    if (!str) return "";
    if (str.length > nums) {
      return str.slice(0, nums) + "...";
    }
    return str;
  },
  /**
   * 空字符过滤器  空显示--
   * @param {*} obj
   */
  emptyFilter: function (obj) {
    if(obj ==  0){
      return obj;
    }
    if (obj == null || obj == "" || obj == undefined) {
      return "--";
    } else {
      return obj;
    }
  }
};
